import { Avatar, Checkbox, Form, FormInstance } from 'antd'
import {
  useCreateRollCall,
  useGetDropCallParticipants,
  useUpdateRollCall,
} from 'api/Event/Attendance'
import Spinner from 'components/Spinner'
import { convertToUtc } from 'helper/utility'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { myStore } from 'state/store'

interface SelectAttendeesProps {
  payload: any
  form: FormInstance
}

const SelectAttendees: React.FC<SelectAttendeesProps> = ({ form, payload }) => {
  const { id }: { id: string } = useParams()
  const { selectedDate, rollCallData, setRollCallData } = eventAttendanceStore(
    store => ({
      selectedDate: store.selectedDate,
      rollCallData: store.rollCallData,
      setRollCallData: store.setRollCallData,
    }),
  )
  const { setRollCallModalOpen, setCheckInOutModalOpen } = eventAttendanceStore(
    store => ({
      setRollCallModalOpen: store.setRollCallModalOpen,
      setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    }),
  )
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [params, setParams] = useState({
    date: convertToUtc(selectedDate),
  })

  const { mutate: createRollCall } = useCreateRollCall()
  const { mutate: updateRollCall } = useUpdateRollCall()

  const {
    data: participants,
    isLoading: isParticipantsLoading,
    isFetching: isParticipantsFetching,
    refetch: refetchParticipants,
  } = useGetDropCallParticipants(id, params)

  const formSchema = {
    participantIds: rollCallData ? rollCallData.participantIds : [],
  }

  const onFinish = values => {
    const finalPayload = {
      ...payload,
      ...values,
      eventId: id,
    }
    setModalBtnLoader(true)

    if (rollCallData) {
      updateRollCall(
        { payload: finalPayload, rollCallId: rollCallData._id },
        {
          onSuccess: () => {
            setRollCallData(null)
            setModalBtnLoader(false)
            setCheckInOutModalOpen(true)
            setRollCallModalOpen(false)
          },
        },
      )
    } else {
      createRollCall(finalPayload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          setCheckInOutModalOpen(true)
          setRollCallModalOpen(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      })
    }
  }

  useEffect(() => {
    refetchParticipants()
  }, [id, params])

  return (
    <>
      {isParticipantsLoading || isParticipantsFetching ? (
        <div className="py-40px flex justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          {participants.length > 0 ? (
            <Form form={form} initialValues={formSchema} onFinish={onFinish}>
              <h5 className="grey-txt">{participants.length} attendees</h5>
              <Form.Item name="participantIds">
                <Checkbox.Group
                  options={participants.map(atendee => ({
                    label: (
                      <div className="flex-center ml-10px">
                        <Avatar
                          size={32}
                          src={atendee.photo?.post}
                        >{`${atendee.firstName} ${atendee.lastName}`}</Avatar>
                        <h2 className="text-16 ml-10">{`${atendee.firstName} ${atendee.lastName}`}</h2>
                      </div>
                    ),
                    value: atendee._id,
                  }))}
                  className="mt-20px atendeeCheckbox"
                />
              </Form.Item>
            </Form>
          ) : (
            <div className="flex-center justify-center h-50">
              <h3 className="text-center text-16">
                No particpants enrolled yet
              </h3>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default SelectAttendees
